import React from "react";
import { Row, Col } from "antd";
import { FormattedMessage } from "react-intl";
import Surface from "../../../components/layouts/Surface";
import FormHeader from "../../../components/forms/FormHeader";
import Spacer from "../../../components/layouts/Spacer";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import ReadOnlyItem from "../../../components/forms/ReadOnlyItem";
import { useSelector } from "react-redux";
import {
  getFullName,
  getLocalPhoneNumber,
} from "../../../components/util/helpers";

const PatientDetails = (props) => {
  const { activeHouseVisit } = props;
  const activePatient = useSelector(
    (state) => state.patientDetails.activePatient
  );
  const patient = activeHouseVisit.patient || activePatient;
  const patientAddress = patient.address
    ? patient.address.city +
      " " +
      patient.address.street +
      " " +
      patient.address.house_number
    : "";

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Surface>
        <FormHeader
          title={<FormattedMessage id="app.house_visits.patient_details" />}
        />
        <Row>
          <Col xs={24} sm={24} md={24} lg={20} xl={18} xxl={18}>
            <ResponsiveItemsWrapper>
              <div style={{ display: "flex", flex: 1 }}>
                <div style={{ display: "flex", flex: 1 }}>
                  <ReadOnlyItem
                    content={getFullName(patient.surename, patient.first_name)}
                    name="patient_name"
                    category="house_visits"
                  />
                </div>
                <Spacer horizontal={true} />
                <div style={{ display: "flex", flex: 1 }}>
                  <ReadOnlyItem
                    content={patient && patient.local_id_number}
                    name="local_id_number"
                    category="house_visits"
                  />
                </div>
                <Spacer horizontal={true} />
                <div style={{ display: "flex", flex: 1 }}>
                  <ReadOnlyItem
                    content={
                      patient.contact_info &&
                      patient.contact_info.phone_number &&
                      getLocalPhoneNumber(patient.contact_info.phone_number)
                    }
                    name="phone_number"
                    category="house_visits"
                  />
                </div>
                <Spacer horizontal={true} />
                <div style={{ display: "flex", flex: 1 }}>
                  <ReadOnlyItem
                    content={patientAddress}
                    name="patient_address"
                    category="house_visits"
                  />
                </div>
              </div>
            </ResponsiveItemsWrapper>
          </Col>
        </Row>
      </Surface>
    </div>
  );
};

export default PatientDetails;
